import React, {useState} from 'react';
import {Col, Container, Dropdown, Row} from 'react-bootstrap';
import {AppNavbar} from '../components/AppNavbar';
import {PLAN, SKUTECNOST, SOUHRN, STATISTIKA, STROM} from '../enums/PohledTypeEnum';
import {StatistikaPanel} from '../components/StatistikaPanel';
import {RouteComponentProps, useHistory} from 'react-router';
import {baseURL, EnumPlanObdobi, StatistikaApi} from '../api';
import {Footer} from '../components/Footer';
import {StatistikaControllerApiAxiosParamCreator} from '../api/api/statistika-controller-api';

type Props = RouteComponentProps<{idVerze: string}, {}>;
export const StatistikaPage: React.FC<Props> = ({match: {params}}) => {
    const [pohledType, setPohledType] = useState(PLAN);

    const history = useHistory();

    const exportStats = (pdf: boolean) => {
        const exportStat = async (pdf: boolean) => {
            let id: string = '';
            try {
                const obdobiEnum = pohledType === SKUTECNOST ? EnumPlanObdobi.SKUTECNOST : EnumPlanObdobi.PLAN;
                id = (await StatistikaApi.exportStatistika(parseInt(params.idVerze), obdobiEnum, pdf)).data;
                const url = baseURL + (await StatistikaControllerApiAxiosParamCreator().downloadStatsExportFile(id, pdf)).url;
                window.open(url);
            } catch (error) {
                // TODO
            }
        };
        exportStat(pdf);
    };

    return (
        <div className="main-div">
            <header>
                <AppNavbar page={'statistika'} idVerze={params.idVerze} planObdobi={pohledType} />
            </header>
            <main>
                <Container fluid>
                    <Row xs="auto" style={{paddingTop: 10, paddingBottom: 10, height: '100%'}}>
                        <Col>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                    {STATISTIKA}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => history.push('/souhrn/' + params.idVerze)}>{SOUHRN}</Dropdown.Item>
                                    <Dropdown.Item onClick={() => history.push('/strom/' + params.idVerze)}>{STROM}</Dropdown.Item>
                                    <Dropdown.Item>{STATISTIKA}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                        <Col>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                    {pohledType}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => setPohledType(PLAN)}>{PLAN}</Dropdown.Item>
                                    <Dropdown.Item onClick={() => setPohledType(SKUTECNOST)}>{SKUTECNOST}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                        <Col className="class-col">
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                    Export
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => exportStats(true)}>pdf</Dropdown.Item>
                                    <Dropdown.Item onClick={() => exportStats(false)}>xls</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    </Row>
                    <Row>
                        <StatistikaPanel planObdobi={pohledType} idVerze={params.idVerze} />
                    </Row>
                </Container>
            </main>
            <footer>
                <Footer idPlanVerze={params.idVerze} />
            </footer>
        </div>
    );
};
